import { GlyphLoading } from "#root/components/glyphs";
import LogViewer from "#root/components/log-viewer";
import { useData } from "#root/utility/hooks";
import type { ReactNode } from "react";
import { getCloudScheduleJobCollectionForTask } from "#root/schema/platform/cloudschedule";
import PageLayout from "../layout";

export default function AdminInvoicePreview({ taskId, jobId }): ReactNode {
  const [details] = useData(async () => {
    if (taskId) {
      return getCloudScheduleJobCollectionForTask(taskId).details(jobId);
    }
  }, [taskId]);

  if (!details) {
    return <GlyphLoading/>;
  }

  const { startTime, endTime, status, output, log } = details?.row || {};

  return (
    <PageLayout title={`CloudSchedule - Task ${taskId} - Job ${jobId}`}>
      <section>
        <h2>Job {jobId}</h2>
        <table className="dl">
          <tbody>
          <tr>
            <th>Start Time</th>
            <td>{startTime}</td>
          </tr>
          <tr>
            <th>End Time</th>
            <td>{endTime}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{status}</td>
          </tr>
          </tbody>
        </table>
        <h2>Job Output:</h2>
        <code>{output}</code>
        <h2>Job Log</h2>
        <LogViewer log={log ?? "[No logged output]"}/>
      </section>
    </PageLayout>
  );
}
